module.exports = __webpack_public_path__ + "img/icMore.d3799242.svg";